import {Component, NgZone, ViewChild} from '@angular/core';
import {Content, NavController, NavParams, Slides, ViewController} from 'ionic-angular';

import {CONFIG} from "../../../app/config";
import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";
import {ENUM, TAction, TChavecoFlag, TProfileFlag, TProfileSexe, TProfileSexo} from "../../../app/enum";

import {StorageService} from "../../../providers/storage-service";
import {HotspotService} from "../../../providers/hotspot-service";

import {LogadoService} from '../../../providers/logado-service';
import {ChavecoMenuPage} from "../chaveco-menu/chaveco-menu";
import {PaybookMenuPage} from "../paybook-menu/paybook-menu";
import {WebsiteSpotPage} from "../website-spot/website-spot";
import {ProfileService} from "../../../providers/profile-service";


@Component({
    selector: 'page-publico-menu',
    templateUrl: 'publico-menu.html',
    providers: [HotspotService, ProfileService]
})
export class PublicoMenuPage {

    @ViewChild(Content) content;
    @ViewChild(Slides) slider: Slides;

    ENUM: any = ENUM;
    config: any;

    TProfileSexe: any = TProfileSexe;
    TProfileFlag: any = TProfileFlag;

    TChavecoFlag: any = TChavecoFlag;

    searching: boolean = false;

    etapa: number;

    branded: any;
    hotspotID: number;
    paybookBase: string;
    paybookFull: boolean;
    
    userset: any;
    monitorBool: boolean;

    logado: any;
    rootile: any;

    startshow: boolean;
    profileSexo: TProfileSexo;
    akkjson = (window as any).handappMainInstance.appjson;

    rootbook: any;

    loaded: boolean = false;
    limitQtde: number = 200;
    limitCount: number = 0;
    limitPage: number = 0;

    constructor(public util: Util, public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController,
                public ngZone: NgZone,
                private storageService: StorageService,
                public logadoService: LogadoService,
                public profileService: ProfileService,
                public hotspotService: HotspotService) {

        this.config = CONFIG;

        this.logado = this.logadoService.getAuth();
        this.rootile = this.navParams.get('rootile');

        this.startshow = false;
        this.rootbook = null;

        this.etapa = this.navParams.get('etapa');
        this.branded = this.navParams.get('branded');
        this.hotspotID = this.navParams.get('hotspotID');
        this.paybookBase = this.navParams.get('paybookBase');
        this.paybookFull = this.navParams.get('paybookFull');
        
        this.userset = this.navParams.get('userset');
        this.monitorBool = this.navParams.get('monitorBool');

        this.storageService.get('PUBLICO-SEXO')
            .subscribe(whatssexo => {
                this.profileSexo = !whatssexo ? TProfileSexo.psNenhum : <TProfileSexo>parseInt(whatssexo);
                this.paybookLoad();
            });

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Publico', '/publico-menu');

    }

    ionViewDidLoad() {


    }

    ionViewDidEnter() {

        let cor = (!this.akkjson.checkin || this.config.negative(this.akkjson.checkin.Branded.BrandedCora) == 'CorMilk');
        this.util.statusBarColor(cor ? TStatusBar.sbStyleLightContent : TStatusBar.sbStyleDefault);

    }

    doScroll(event) {

        if (this.content.getScrollElement().scrollTop == 0) return;
        this.content.scrollTo(0, 0, 1000);
        this.paybookLoad();

    }

    getTitle() {

        if (this.etapa == 0) return 'Checkin';
        if (this.etapa == 1) return this.akkjson.checkin.Branded.BrandedNome;

    }

    publicoLove() {

        //Save
        this.startshow = false;
        this.storageService.set('PUBLICO-LOVE', true).subscribe();

    }

    paybookDate() {

        if (this.paybookBase == 'CURRENT_TIMESTAMP') {

            let turn = this.akkjson.hotwork.Hotspot.HotspotTurn;
            let date = this.util.dateHoje();
            if (this.util.dateHoje().getHours() < turn) date.setDate(date.getDate() - 1);

            return this.util.dateToStr(date);

        }

        return this.paybookBase;

    }

    paybookLoad(eventMais?: any) {

        this.searching = true;


        //#MONITOR
        if (this.userset || !this.userset) {
            let params = '&WorkdayID=0';

            let loading = this.util.loadingDots();
            loading.present();
    
            this.util.monitorDesk(this.monitorBool, 'DESK-Comanda', this.hotspotID, params, TAction.acLoad)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => {
                        this.rootbook = data
                        this.rootbook.Paybooks = data.Comandas;
                        this.rootbook.Sexbooks = data.Comandas;
                        this.paybookSexo();
                    },
                    erro => this.util.alertResult(erro));
    
            return;
        }




        //#BRIDGE
        let params = '&PaybookBase=' + this.paybookBase + '&LimitPage=' + this.limitPage + '&LimitQtde=' + this.limitQtde;
        let action = (this.paybookFull ? TAction.acLove : TAction.acMigo);

        this.hotspotService.paybook(action, 0, this.hotspotID, 0, this.rootile.Profile.ProfileID, '', null, params)
            .finally(() => {

                this.searching = false;
                this.ionViewDidEnter();

            })
            .subscribe(
                data => {

                    this.storageService.get('PUBLICO-LOVE').subscribe(bool => {
                        this.startshow = !bool;

                        if (this.slider) this.slider.slideTo(0, 0);

                        if (this.rootbook) {
                            Array.prototype.push.apply(this.rootbook.Paybooks, data.Paybooks);
                            console.log(this.rootbook.Paybooks);
                        }

                        if (!this.rootbook) {
                            this.rootbook = data;
                            this.rootbook.Paybooks = data.Paybooks;
                            //this.content.resize();
                        }

                        this.paybookSexo();

                        this.limitCount = data.Paybooks.length;
                        this.limitQtde = data.LimitQtde;
                        this.limitPage = data.LimitPage;
                        this.loaded = true;
                        if (eventMais) eventMais.complete();
                    });

                },
                erro => {

                    this.rootbook = null;
                    this.util.alertResult(erro);

                });

    }

    paybookMenu(paybook) {

        let branded = this.branded || paybook.Branded;
        let workday = !!this.userset;
        let object = {etapa: 0, olhaapp: false, monitorBool: this.monitorBool, fronter: false, profile: null, branded: branded, workday: workday, userset: null, paybookID: paybook.PaybookID, paybook: null, hotspotID: this.hotspotID};
        this.util.modalopen(PaybookMenuPage, 'alto', false, object).subscribe();

    }

    profileOpen(paybook, force: boolean = false) {

        let zito = false;//(this.logado.Profile.ProfileZito && force);
        let book = (zito || this.userset);
        let open = (zito || !book);

        /** OPEN **/
        let buttons: Array<any> = [];
        if (open) buttons.push({text: 'Open', handler: () => this.chavecoMenu(paybook)});
        if (book) buttons.push({text: 'Book', handler: () => this.paybookMenu(paybook)});
        this.util.sheetOpen(buttons, 'ACTION');

    }

    hotspotPage(hotspotID, branded) {

        let object = {hotspotID: hotspotID, brandex: branded, tabmenu: true};
        this.navCtrl.push(WebsiteSpotPage, object);

    }

    paybookSexo() {

        this.rootbook.Sexbooks = this.rootbook.Paybooks.filter(paybook => (this.profileSexo == TProfileSexo.psNenhum || paybook.Profile.ProfileSexo == this.profileSexo));
        this.ngZone.run(() => {});

    }

    chavecoSexo() {

        let onSexo = (sexo) => {
            this.storageService.set('PUBLICO-SEXO', sexo).subscribe();
            this.profileSexo = sexo;
            this.paybookLoad();
        };

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Muiê', handler: () => onSexo(TProfileSexo.psFeminino)});
        buttons.push({text: 'Hômi', handler: () => onSexo(TProfileSexo.psMasculino)});
        buttons.push({text: 'Tudo', handler: () => onSexo(TProfileSexo.psNenhum)});
        this.util.sheetOpen(buttons, 'ACTION');

    }

    chavecoMenu(paybook) {

        let chaveco = paybook.Chaveco;

        let object = {etapa: 0, profile: paybook.Profile, chaveco: chaveco};
        this.navCtrl.push(ChavecoMenuPage, object, {animate: false});

        //VISITOR
        this.profileService.visitor(TAction.acSave, paybook.Profile.ProfileID)
            .subscribe(
                data => {},
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    chavecoList() {

        let object = {etapa: 1, profile: this.logado.Profile, chaveco: null};
        this.navCtrl.push(ChavecoMenuPage, object);

    }

    dismiss() {

        this.navCtrl.pop({animation: 'md-transition'});

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/publico-menu/publico-menu.ts